import React, { useEffect, useState } from 'react';
import './ApplicationsSection.css';
import publicAxios from '../../utils/axios/publicAxios';
import { Link } from 'react-router-dom';

const ApplicationsSection = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(false);

  const stripHtmlAndTruncate = (html, maxLength = 30) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || "";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        setLoading(true);
        const response = await publicAxios.get('/public/three-forms');
        setApplications(response.data.forms);
      } catch (error) {
        console.error('Error:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchApplications();
  }, []);

  return (
    <section className="application-section">
      {loading ? (
        <div>Loading Applications</div>
      ) : applications.length ? (
        <div className="application-section-wrapper">
          <div className="application-section-title-div">
            <Link to={'/applications'} className="application-section-title">Latest Applications</Link>
          </div>
          <div className="application-section-grid">
            {applications.map((application, index) => (
              <div className="application-section-card" key={application._id || index}>
                <div className="application-image">
                  <img src={application.imageUrl} alt={application.title} />
                </div>
                <div className="application-details">
                  <h3>{application.title}</h3>
                  <p>{stripHtmlAndTruncate(application.description, 150)}</p>
                  <div className="application-section-read-more-div">
                    <Link to={`/application/${application._id}`} className="read-more">Read more...</Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        null
      )}
    </section>
  );
};

export default ApplicationsSection;